import { Component } from '@angular/core';

@Component({
    selector: 'dashboard-docs',
    templateUrl: './dashboard-docs.component.html',
    styleUrls: ['./dashboard-docs.component.scss'],
    standalone: false
})
export class DashboardDocsComponent {
}
